import React, { Fragment, useEffect, useState } from 'react';
import useAction from '@pages/landing-page/hooks/useAction';
import useActionTopics from "@pages/topics/hooks/useAction";
import useActionCrawler from "@pages/news-crawler/hooks/useAction";
import LandingPageForm from './landingPageFrom';
import PreviewPage from "./landingPagePreview";
import SectionForm from "./section";
import { IResponseLandingSection, IResponseSectionFrames } from '@interfaces/iresponse-landing-page';
import { GetValidateFields, Confirm } from 'asumsi-components';

export default function (props: any) {
    const { isLoader, detail, getData, data, getDetail, postData, updateData } = useAction();
    const { getData: getTopics, isLoader: isLoaderTopics, data: topics } = useActionTopics();
    const { getData: getDataCrawl, data: dataCrawl, isLoaderData: loaderDataCrawl, isLoaderNewsMedia: loaderSource, getSources, sources } = useActionCrawler();
    const { getData: getDataCrawl2, data: dataCrawl2, isLoaderData: loaderDataCrawl2 } = useActionCrawler();
    const { getData: getDataCrawl3, data: dataCrawl3, isLoaderData: loaderDataCrawl3 } = useActionCrawler();
    const [showSectionForm, setShowSectionForm] = useState(false);
    const [showPreviewPage, setShowPreviewPage] = useState(false);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState();
    const { match } = props;
    const idData = match.params.id;
    // first load
    useEffect(() => {
        fetchMaster();
        if (idData) {
            fetchDetail();
        }
    }, [])

    // fetch data
    const fetchDetail = () => {
        getDetail(idData);
    }

    const fetchMaster = () => {
        getTopics({ page: 1, limit: 10, all: true });
        getData({ page: 1, limit: 10, all: true });
        getSources();
    }

    // initiate form data
    const initialFieldsValues: any = {
        title: "",
        slug: "",
        topicId: "",
        checkPointType: 1,
        sections: [],
        nextLandingPageId: "",
        prevLandingPageId: ""
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);

    const initialFieldsValuesSection: any = {
        checkPointGroup: "",
        checkPoint: "",
        checkPointDesc: "",
        content: null,
        frames: [],
        orderNumber: null
    }
    const [fieldsValuesSection, setFieldsValuesSection]: any = useState(initialFieldsValuesSection);

    const addSection = async () => {
        await setFieldsValuesSection({
            checkPointGroup: "",
            checkPoint: "",
            checkPointDesc: "",
            content: null,
            frames: [],
            orderNumber: null
        });
        setShowSectionForm(true);
    }

    const editSection = async (sec: IResponseLandingSection) => {
        let newValue: any = null;
        if (sec.frames)
            sec.frames.forEach((fr: any) => {
                const param: any = { page: 1, limit: 100, status: 'published', newsMedia: fr.soutce };
                switch (fr.orderNumber) {
                    case 1:
                        getDataCrawl(param)
                        break;
                    case 2:
                        getDataCrawl2(param)
                        break;
                    case 3:
                        getDataCrawl3(param)
                        break;

                    default:
                        break;
                }
                const strValue = JSON.parse(`{"source${fr.orderNumber}": "${fr.source ?? ''}", "url${fr.orderNumber}": "${fr.url ?? ''}"}`);
                newValue = { ...newValue, ...Object.assign(strValue) };
            });

        await setFieldsValuesSection({
            checkPointGroup: sec.checkPointGroup,
            checkPoint: sec.checkPoint,
            checkPointDesc: sec.checkPointDesc,
            content: sec.content,
            frames: sec.frames,
            orderNumber: sec.orderNumber,
            ...newValue
        });
        setShowSectionForm(true);
    }

    const submitSection = (newDataValue: any) => {
        const validateFields = GetValidateFields(newDataValue);
        const { err, values } = validateFields;
        if (!err) {
            const newData: any = values;
            const sections: IResponseLandingSection[] = fieldsValues.sections;
            const indexSection = fieldsValues.sections.findIndex((sec: IResponseLandingSection) => sec.orderNumber == newData.orderNumber);
            const newSection: IResponseLandingSection = {
                checkPointGroup: newData.checkPointGroup,
                checkPoint: newData.checkPoint,
                checkPointDesc: newData.checkPointDesc,
                content: newData.content,
                frames: newData.frames,
                orderNumber: indexSection >= 0 ? newData.orderNumber : fieldsValues.sections.length + 1
            };

            const frames: IResponseSectionFrames[] = [];

            for (let index = 1; index <= 3; index++) {
                if (newData[`source${index}`] && newData[`url${index}`]) {
                    frames.push({ orderNumber: index, source: newData[`source${index}`], url: newData[`url${index}`] });
                }
            }

            newSection.frames = frames;
            if (indexSection >= 0) {
                sections[indexSection] = newSection;
            } else {
                sections.push(newSection);
            }

            setFieldsValues({ ...fieldsValues, sections: sections })
            setShowSectionForm(false);
        }
    }

    const cancelAddSection = () => {
        setShowSectionForm(false);
        setFieldsValuesSection(initialFieldsValuesSection);
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            const val: any = values;
            if (val.heroImageLargeUrl == detail.heroImageLargeUrl && detail.heroImageLargeUrl != null) {
                delete val.heroImageLarge;
            }

            if (val.heroImageSmallUrl == detail.heroImageSmallUrl && detail.heroImageSmallUrl != null) {
                delete val.heroImageSmall;
            }

            if (!idData || val.heroImageLarge) delete val.heroImageLargeUrl;
            if (!idData || val.heroImageSmall) delete val.heroImageSmallUrl;

            val.nextLandingPageId = val.nextLandingPageId && val.nextLandingPageId != "" ? val.nextLandingPageId : undefined;
            val.prevLandingPageId = val.prevLandingPageId && val.prevLandingPageId != "" ? val.prevLandingPageId : undefined;

            Object.keys(val).forEach(key => val[key] === undefined && delete val[key]);
            const param: any = {
                ...val,
                checkPointType: `${val.checkPointType}`,
                sections: JSON.stringify(val.sections),
                status: val.status == true ? 'published' : idData && detail.status == 'published' ? 'unpublished' : 'draft'
            };
            setParamSubmit(param);
            setShowConfirm(true);
        }
    };

    const onPreview = () => {
        setShowPreviewPage(true);
    }

    return (
        <Fragment>
            <LandingPageForm
                isLoader={isLoader}
                handleSubmit={handleSubmit}
                setFieldsValues={setFieldsValues}
                fieldsValues={fieldsValues}
                addSection={addSection}
                previewPages={onPreview}
                editSection={editSection}
                isLoaderTopics={isLoaderTopics}
                topics={topics}
                otherLanding={data}
                detail={detail}
                idData={idData}
                show={!showSectionForm}
            />
            {showSectionForm ? <SectionForm
                getDataCrawl2={getDataCrawl2}
                getDataCrawl3={getDataCrawl3}
                loaderDataCrawl2={loaderDataCrawl2}
                loaderDataCrawl3={loaderDataCrawl3}
                dataCrawl2={dataCrawl2}
                dataCrawl3={dataCrawl3}
                loaderDataCrawl={loaderDataCrawl}
                loaderSource={loaderSource}
                getDataCrawl={getDataCrawl}
                dataCrawl={dataCrawl}
                sources={sources}
                checkPointType={fieldsValues.checkPointType}
                submitSection={submitSection}
                cancelAddSection={cancelAddSection}
                isLoader={isLoader}
                fieldsValuesSection={fieldsValuesSection} /> : null}
            {showPreviewPage ? <PreviewPage previewSlug={fieldsValues.slug} setShowPreviewPage={setShowPreviewPage} showPreviewPage={showPreviewPage} /> : null}
            <Confirm
                key="confirm-delete"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    if (!idData) {
                        // do post data
                        postData(paramSubmit);
                    } else {
                        // do update data
                        updateData(paramSubmit, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/landing-page-form/libraries/index.tsx